<template>
  <div id="booking-section">
    <booking-section />
  </div>
</template>

<script>
  import BookingSection from "./components/Booking";

  export default {
    name: "booking",
    components: {
      BookingSection
    }
  };
</script>


